<template>
    <div>
        <div style="padding:15px;">
            <img :src="require('@/assets/images/coach_register/coach_regi_screen_x_btn.png')" style="width:14px; height:14px;" @click="() => {$GlobalStore.closeLastModal()}">
        </div>
        <div style="flex:1;display:grid; place-items: center;">
            <div style="display:flex; justify-content: center; flex-direction: column;">
                <template v-if="type === COACH_DOC_COMPLETE.COMPLETE">
                    <div style="text-align:center;">
                        <img :src="require('@/assets/images/coach_register/coach_regi_sign.png')" style="width:156px; height:97px;">
                    </div>
                    <div style="margin-top:30px;">
                        <div class="title">성공적으로 제출되었습니다.</div>
                        <div class="contents" style="margin-top:20px;">제출하신 모든 내용을 검토하고 있습니다.</div>
                    </div>
                    <div style="height:80px;"></div>
                    <div style="margin-bottom:20px; color:#210F03; font-size:12px; font-weight:500;">확인 절차에 따라 최대 하루 이상의 시간이 소요될 수 있습니다.</div>
                </template>
                <template v-else-if="type === COACH_DOC_COMPLETE.PROGRESSING">
                    <div style="text-align:center;">
                        <img :src="require('@/assets/images/coach_register/coach_regi_doc_complete.png')" style="width:97px; height:126px;">
                    </div>
                    <div style="margin-top:30px;">
                        <div class="title">코치님의 선수 정보와 신원 정보를<br/>조회하고 있습니다.</div>
                        <div class="contents" style="margin-top:20px;">제출하신 모든 내용을 확인중입니다.<br>또한 코치님에 대한 지원방향을 검토하고 있습니다.</div>
                    </div>
                    <div style="height:100px;"></div>
                </template>
                <template v-else-if="type === COACH_DOC_COMPLETE.CERT_CHANGE_COMPLETE">
                    <div style="text-align:center;">
                        <img :src="require('@/assets/images/coach_register/coach_regi_sign.png')" style="width:156px; height:97px;">
                    </div>
                    <div style="margin-top:30px;">
                        <div class="title">변경 요청했습니다.</div>
                        <div class="contents" style="margin-top:20px;">요청하신 내용을 검토하고 있습니다.</div>
                    </div>
                    <div style="height:80px;"></div>
                    <div style="margin-bottom:20px; color:#210F03; font-size:12px; font-weight:500;">확인 절차에 따라 최대 하루 이상의 시간이 소요될 수 있습니다.</div>
                </template>
                <template v-if="type === COACH_DOC_COMPLETE.EXPLANATION">
                    <div style="text-align:center;">
                        <img :src="require('@/assets/images/coach_register/coach_regi_doc_complete.png')" style="width:97px; height:126px;">
                    </div>
                    <div style="margin-top:30px;">
                        <div class="title">선수인증하기</div>
                        <div class="contents" style="margin-top:20px;">우선 사커하우에서 코치로 활동하기 위해서는<br>선수 인증 절차가 필요합니다.<br>아래의 서류를 준비해주시기 바랍니다.</div>
                    </div>
                    <div style="border-radius:12px; background-color: #F5F5F5; padding: 12px 20px; margin-top:30px; ">
                        <div class="doc_title"><span style="font-weight:bold;">·</span> 조인 KFA 선수경력증명서</div>
                        <div class="doc_title"><span style="font-weight:bold;">·</span> 주민등록등본</div>
                        <div class="doc_title"><span style="font-weight:bold;">·</span> 통장사본</div>
                    </div>
                    <div style="height:30px;"></div>
                </template>

                <div style="margin-top:30px;">
                    <template v-if="type === COACH_DOC_COMPLETE.EXPLANATION">
                        <div style="border-radius:30px; height: 60px; background-color: black; color:white; font-weight:500; font-size:16px;display:grid; place-items: center; " @click="goCoachDocRegister">다음</div>
                    </template>
                    <template v-else>
                        <div style="border-radius:30px; height: 60px; background-color: black; color:white; font-weight:500; font-size:16px;display:grid; place-items: center; " @click="() => {$GlobalStore.closeLastModal()}">확인</div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {FORM_MODE} from "../../../Constants";
    import {COACH_DOC_REGISTER_TYPE} from "./CoachDocRegister";

    export const COACH_DOC_COMPLETE = {
        COMPLETE : 0,
        PROGRESSING : 1,
        CERT_CHANGE_COMPLETE : 2,
        EXPLANATION : 3,
    }

    export default {
        name: "CoachDocComplete",
        props: {
            type : {
                type : Number,
                default : COACH_DOC_COMPLETE.COMPLETE
            }
        },
        data(){
            return {
                COACH_DOC_COMPLETE : COACH_DOC_COMPLETE
            }
        },
        methods : {
            goCoachDocRegister(){
                this.$GlobalStore.addModal('CoachDocRegister', {mode : FORM_MODE.INSERT, type : COACH_DOC_REGISTER_TYPE.DEFAULT_INFO});
            }
        }
    }
</script>

<style scoped>
    .title{font-size:20px; font-weight:bold; color:#2B1303; text-align:center;line-height: 29px;}
    .contents{font-size:16px; font-weight:500; color:#210F03;line-height: 24px; text-align:center;}
    .doc_title{font-size:16px; font-weight:500; color:#210F03}
    .doc_title + .doc_title{margin-top:5px;}
</style>